"use client";

import { useState } from "react";
import styles from "./contactForm.module.css";

export default function ContactoPage() {
  const [formData, setFormData] = useState({
    brandName: "",
    instagram: "",
    contactName: "",
    phone: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Enviando...");
    try {
      const res = await fetch("/api/send-contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        setStatus("¡Mensaje enviado con éxito!");
        setFormData({
          brandName: "",
          instagram: "",
          contactName: "",
          phone: "",
        });
      } else {
        setStatus("Hubo un error al enviar.");
      }
    } catch (err) {
      setStatus("Error de red.");
    }
  };

  return (
    <main className={styles.mainContainer}>
      <section className={styles.sectionContainer}>
        <div className={styles.titlesContainer}>
          <h1 className={styles.title}>Contactanos</h1>
          <p className={styles.subtitle}>
            Contactanos para conocer nuestros precios
          </p>
        </div>
        <div className={styles.formContainer}>
          <div className={styles.inputContainer}>
            <label className={styles.labelElement}>Nombre de la Marca</label>
            <input
              className={styles.inputElement}
              name="brandName"
              value={formData.brandName}
              onChange={handleChange}
              required
              placeholder="Escribe el nombre de tu marca"
            />
          </div>

          <div className={styles.inputContainer}>
            <label className={styles.labelElement}>Instagram de la Marca</label>
            <input
              className={styles.inputElement}
              name="instagram"
              value={formData.instagram}
              onChange={handleChange}
              required
              placeholder="Escribe el instagram de tu marca"
            />
          </div>

          <div className={styles.inputContainer}>
            <label className={styles.labelElement}>Nombre de Contacto</label>
            <input
              className={styles.inputElement}
              name="contactName"
              value={formData.contactName}
              onChange={handleChange}
              required
              placeholder="Escribe tu nombre"
            />
          </div>

          <div className={styles.inputContainer}>
            <label className={styles.labelElement}>Teléfono del Cliente</label>
            <input
              className={styles.inputElement}
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Escribe el número de teléfono"
            />
          </div>
        </div>

        <div className={styles.btnContainer}>
          <button className={styles.sendBtn} type="submit">
            Enviar
          </button>
        </div>
      </section>
    </main>
  );
}
